export default __webpack_public_path__ + "static/media/Pessoa_fisica_on.970a0d41.svg";